require("../map-content/map-content");

const adminRoot = document.querySelector("[data-admin-root]");

function initAdminMapContent() {
  const store = window.NMMapContent;
  if (!store || !adminRoot || window.NMAdminMapContent) return;

  const mapView = document.querySelector('[data-admin-view="map"]');
  const mapCanvas = document.querySelector("[data-admin-map]");
  const regionsCount = document.querySelector("[data-map-regions-count]");
  const regionsList = document.querySelector("[data-map-regions-list]");

  const regionModal = document.querySelector("[data-map-region-modal]");
  const regionForm = document.querySelector("[data-map-region-form]");
  const regionFormTitle = document.querySelector("[data-map-region-form-title]");
  const regionFormDesc = document.querySelector("[data-map-region-form-desc]");
  const regionIdInput = document.querySelector("[data-map-region-id]");
  const worksBlock = document.querySelector("[data-map-works-block]");
  const worksList = document.querySelector("[data-map-works-list]");
  const regionDeleteBtn = document.querySelector("[data-map-region-delete]");
  const workCreateBtn = document.querySelector("[data-map-work-create]");

  const workModal = document.querySelector("[data-map-work-modal]");
  const workForm = document.querySelector("[data-map-work-form]");
  const workFormTitle = document.querySelector("[data-map-work-form-title]");
  const workIdInput = document.querySelector("[data-map-work-id]");

  if (!mapView || !mapCanvas || !regionForm) return;

  let draftRegion = null;
  let editingWorkId = null;
  let mapReady = false;

  function clearRegionErrors() {
    regionForm.querySelectorAll("[data-map-region-field]").forEach((field) => {
      field.classList.remove("has-error");
      const error = field.querySelector("[data-map-region-error]");
      if (error) error.hidden = true;
    });
  }

  function showRegionError(name) {
    const field = regionForm.querySelector(`[data-map-region-field="${name}"]`);
    if (!field) return;
    field.classList.add("has-error");
    const error = field.querySelector("[data-map-region-error]");
    if (error) error.hidden = false;
  }

  function clearWorkErrors() {
    workForm?.querySelectorAll("[data-map-work-field]").forEach((field) => {
      field.classList.remove("has-error");
      const error = field.querySelector("[data-map-work-error]");
      if (error) error.hidden = true;
    });
  }

  function showWorkError(name) {
    const field = workForm?.querySelector(`[data-map-work-field="${name}"]`);
    if (!field) return;
    field.classList.add("has-error");
    const error = field.querySelector("[data-map-work-error]");
    if (error) error.hidden = false;
  }

  function getSvg() {
    return mapCanvas.querySelector(".location-section__map");
  }

  function setActivePath(regionId) {
    const svg = getSvg();
    if (!svg) return;
    svg.querySelectorAll("[data-region-id]").forEach((path) => {
      path.classList.toggle("is-active", path.getAttribute("data-region-id") === regionId);
    });
  }

  function renderWorksList() {
    if (!worksList || !draftRegion) return;
    const works = Array.isArray(draftRegion.works) ? draftRegion.works : [];

    if (!works.length) {
      worksList.innerHTML = `
        <div class="admin-panel__map-empty">
          <p class="admin-panel__map-empty-title">Пока нет работ</p>
          <p class="admin-panel__hint p3">Добавьте первую запись в историю этого региона</p>
        </div>
      `;
      return;
    }

    worksList.innerHTML = works.map((work) => `
      <article class="admin-panel__map-work-card">
        <div class="admin-panel__map-work-card-body">
          <span class="admin-panel__map-work-year">${store.escapeHtml(work.year || "—")}</span>
          <h5 class="admin-panel__map-work-org">${store.escapeHtml(work.organization || "")}</h5>
          <p class="admin-panel__map-work-service">
            ${store.escapeHtml(work.service || "")}
            ${work.serviceUrl ? ` · <a href="${store.escapeHtml(work.serviceUrl)}" target="_blank" rel="noopener noreferrer">ссылка</a>` : ""}
          </p>
        </div>
        <div class="admin-panel__map-work-card-actions">
          <button class="admin-panel__action-btn" type="button" data-map-work-edit="${store.escapeHtml(work.id)}">Изменить</button>
          <button class="admin-panel__action-btn admin-panel__action-btn_danger" type="button" data-map-work-delete="${store.escapeHtml(work.id)}">Удалить</button>
        </div>
      </article>
    `).join("");
  }

  function renderRegionsList() {
    const data = store.getMapData();
    if (regionsCount) regionsCount.textContent = `Регионов: ${data.regions.length}`;
    if (!regionsList) return;

    if (!data.regions.length) {
      regionsList.innerHTML = `
        <div class="admin-panel__map-empty">
          <p class="admin-panel__map-empty-title">Пока нет подписанных регионов</p>
          <p class="admin-panel__hint p3">Кликните по области на карте, чтобы назвать регион</p>
        </div>
      `;
      return;
    }

    regionsList.innerHTML = data.regions.map((region) => {
      const worksCount = Array.isArray(region.works) ? region.works.length : 0;
      return `
        <article class="admin-panel__map-region-card">
          <div class="admin-panel__map-region-card-body">
            <h4 class="admin-panel__map-region-card-title">${store.escapeHtml(region.title)}</h4>
            <div class="admin-panel__map-region-card-tags">
              <span class="admin-panel__map-region-stat">Работ: ${worksCount}</span>
            </div>
          </div>
          <div class="admin-panel__map-region-card-actions">
            <button class="admin-panel__action-btn" type="button" data-map-region-open="${store.escapeHtml(region.id)}">Настроить</button>
          </div>
        </article>
      `;
    }).join("");
  }

  function refreshMap() {
    const svg = getSvg();
    if (!svg) return;
    store.prepareMapSvg(svg);
    store.applyNamedRegions(svg);
    store.renderLocationMarks(mapCanvas, store.getMapData(), { forcePoppers: false });
    renderRegionsList();
  }

  function closeRegionModal() {
    if (!regionModal) return;
    regionModal.hidden = true;
    draftRegion = null;
    setActivePath("");
    clearRegionErrors();
  }

  function closeWorkModal() {
    if (!workModal) return;
    workModal.hidden = true;
    editingWorkId = null;
    clearWorkErrors();
    if (workForm) workForm.reset();
  }

  function openRegionModal(regionId) {
    const existing = store.getRegionById(regionId);
    draftRegion = existing
      ? {
        id: existing.id,
        title: existing.title,
        works: existing.works.map((item) => ({ ...item })),
      }
      : {
        id: regionId,
        title: "",
        works: [],
      };

    if (regionIdInput) regionIdInput.value = draftRegion.id;
    if (regionForm) regionForm.elements.title.value = draftRegion.title;
    if (regionFormTitle) {
      regionFormTitle.textContent = existing ? "Редактирование региона" : "Новый регион";
    }
    if (regionFormDesc) {
      regionFormDesc.textContent = existing
        ? "Измените название и историю работ для этой области"
        : "Укажите название области на карте";
    }
    if (worksBlock) worksBlock.hidden = false;
    if (regionDeleteBtn) regionDeleteBtn.hidden = !existing;

    clearRegionErrors();
    renderWorksList();
    setActivePath(regionId);
    if (regionModal) regionModal.hidden = false;
  }

  function openWorkModal(workId) {
    if (!workForm || !draftRegion) return;
    const work = workId
      ? draftRegion.works.find((item) => item.id === workId)
      : null;
    editingWorkId = work ? work.id : null;

    if (workIdInput) workIdInput.value = work ? work.id : "";
    workForm.elements.year.value = work?.year || "";
    workForm.elements.organization.value = work?.organization || "";
    workForm.elements.service.value = work?.service || "";
    workForm.elements.serviceUrl.value = work?.serviceUrl || "";
    if (workFormTitle) {
      workFormTitle.textContent = work ? "Изменить работу" : "Новая работа";
    }
    clearWorkErrors();
    if (workModal) workModal.hidden = false;
  }

  function ensureMapReady() {
    if (mapReady) {
      refreshMap();
      return;
    }
    refreshMap();
    mapReady = true;

    mapCanvas.addEventListener("click", (event) => {
      const mark = event.target.closest("[data-location-open]");
      if (mark) {
        event.preventDefault();
        openRegionModal(mark.getAttribute("data-location-open"));
        return;
      }

      const path = event.target.closest("[data-region-id]");
      if (!path) return;
      event.preventDefault();
      openRegionModal(path.getAttribute("data-region-id"));
    });
  }

  function handleRegionSubmit(event) {
    event.preventDefault();
    if (!draftRegion) return;
    clearRegionErrors();

    const title = String(regionForm.elements.title.value || "").trim();
    if (!title) {
      showRegionError("title");
      return;
    }

    draftRegion.title = title;
    store.upsertRegion(draftRegion);
    closeRegionModal();
    refreshMap();
    if (typeof window.NMMapContent?.hydratePublicMaps === "function") {
      window.NMMapContent.hydratePublicMaps();
    }
  }

  function handleWorkSubmit(event) {
    event.preventDefault();
    if (!draftRegion || !workForm) return;
    clearWorkErrors();

    const year = String(workForm.elements.year.value || "").trim();
    const organization = String(workForm.elements.organization.value || "").trim();
    const service = String(workForm.elements.service.value || "").trim();
    const serviceUrl = String(workForm.elements.serviceUrl.value || "").trim();

    let hasError = false;
    if (!year) {
      showWorkError("year");
      hasError = true;
    }
    if (!organization) {
      showWorkError("organization");
      hasError = true;
    }
    if (!service) {
      showWorkError("service");
      hasError = true;
    }
    if (hasError) return;

    const nextWork = {
      id: editingWorkId || store.createId(),
      year,
      organization,
      service,
      serviceUrl,
    };

    const index = draftRegion.works.findIndex((item) => item.id === nextWork.id);
    if (index >= 0) {
      draftRegion.works[index] = nextWork;
    } else {
      draftRegion.works.push(nextWork);
    }

    closeWorkModal();
    renderWorksList();
  }

  regionForm.addEventListener("submit", handleRegionSubmit);
  workForm?.addEventListener("submit", handleWorkSubmit);

  workCreateBtn?.addEventListener("click", () => openWorkModal(null));

  regionDeleteBtn?.addEventListener("click", () => {
    if (!draftRegion) return;
    const confirmed = window.confirm(`Удалить регион «${draftRegion.title || draftRegion.id}»?`); // eslint-disable-line no-alert
    if (!confirmed) return;
    store.deleteRegion(draftRegion.id);
    closeRegionModal();
    refreshMap();
    window.NMMapContent?.hydratePublicMaps?.();
  });

  document.querySelectorAll("[data-map-region-modal-close]").forEach((el) => {
    el.addEventListener("click", () => {
      closeRegionModal();
    });
  });

  document.querySelectorAll("[data-map-work-modal-close]").forEach((el) => {
    el.addEventListener("click", () => {
      closeWorkModal();
    });
  });

  worksList?.addEventListener("click", (event) => {
    const editBtn = event.target.closest("[data-map-work-edit]");
    const deleteBtn = event.target.closest("[data-map-work-delete]");
    if (editBtn) {
      openWorkModal(editBtn.getAttribute("data-map-work-edit"));
      return;
    }
    if (deleteBtn && draftRegion) {
      const id = deleteBtn.getAttribute("data-map-work-delete");
      draftRegion.works = draftRegion.works.filter((item) => item.id !== id);
      renderWorksList();
    }
  });

  regionsList?.addEventListener("click", (event) => {
    const openBtn = event.target.closest("[data-map-region-open]");
    if (!openBtn) return;
    openRegionModal(openBtn.getAttribute("data-map-region-open"));
  });

  window.NMAdminMapContent = {
    ensureMapReady,
    refreshMap,
  };

  if (!mapView.hidden) ensureMapReady();
}

initAdminMapContent();

document.addEventListener("nm:admin-view", (event) => {
  if (event.detail?.route === "map") {
    window.NMAdminMapContent?.ensureMapReady?.();
  }
});
